<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<style>
  .features .feture-tabs {
      margin-top: 0px !important;
  }
</style>

<section class="features">
  <div class="container" data-aos="fade-up">
    <div class="row feture-tabs" data-aos="fade-up">
      <div class="col-lg-6">
        <h3>{text(block, 'title')}</h3>

        <!-- Tabs -->
        <ul class="nav nav-pills mb-3">
          {#each blocklist(block, 'tabs') as item, index}
          <li>
            <a class="nav-link {index === 0 ? 'active' : ''}" data-bs-toggle="pill" href="#tab{index}">{text(item, 'title')}</a>
          </li>
          {/each}
        </ul><!-- End Tabs -->

        <!-- Tab Content -->
        <div class="tab-content">
          {#each blocklist(block, 'tabs') as item, index}
          <div class="tab-pane fade show active" id="tab{index}">
            <p>{@html richtext(item, 'body')}</p>
          </div>
          {/each}
        </div>
      </div>

      <div class="col-lg-6">
        <img src="{image(block, 'picture', [800, 800])}" class="img-fluid" alt="">
      </div>

    </div>
  </div>
</section>
